(() => {
  if (window.__tlHomeV1) return;
  window.__tlHomeV1 = true;
  function updateCard(card, data) {
    if (data.price) card.querySelector('[data-tl-price]').textContent = data.price;
    if (data.url) card.querySelectorAll('[data-tl-product-link]').forEach(a => a.href = data.url);
    if (data.image) {
      const img = card.querySelector('.tl-h-floating img');
      if (img) { img.removeAttribute('srcset'); img.src = data.image; }
    }
  }
  function init(root) {
    if (root.dataset.tlReady) return;
    root.dataset.tlReady = 'true';
    root.querySelectorAll('.tl-h-photo:has(.tl-h-hover)').forEach(photo=>{
      photo.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')photo.classList.add('is-hover')});
      photo.addEventListener('pointerleave',()=>photo.classList.remove('is-hover'));
      photo.addEventListener('blur',()=>photo.classList.remove('is-hover'));
    });
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    function selectTab(tab) {
      tabs.forEach(t => {
        const active = t === tab;
        t.setAttribute('aria-selected', String(active));
        t.tabIndex = active ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !active;
      });
    }
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => selectTab(tab));
      tab.addEventListener('keydown', e => {
        const indices = {ArrowRight:(i + 1) % tabs.length,ArrowLeft:(i + tabs.length - 1) % tabs.length,Home:0,End:tabs.length - 1};
        if (e.key in indices) { e.preventDefault(); const next = tabs[indices[e.key]]; selectTab(next); next.focus(); }
      });
    });
    root.querySelectorAll('[data-tl-swatch]').forEach(button => button.addEventListener('click', () => {
      const card = button.closest('[data-tl-card]');
      card.querySelectorAll('[data-tl-swatch]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      updateCard(card, button.dataset);
    }));
    root.querySelectorAll('[data-tl-variant]').forEach(select => select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      const card = select.closest('[data-tl-card]');
      updateCard(card, option.dataset);
      const button = card.querySelector('[type="submit"]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? 'Agotado' : 'Añadir al carrito';
    }));
    const checkReviews = () => root.querySelectorAll('[data-tl-judge]').forEach(box => {
      const badge = box.querySelector('[data-number-of-reviews]');
      box.hidden = !(badge && Number(badge.dataset.numberOfReviews) > 0);
    });
    checkReviews();
    const observer = new MutationObserver(checkReviews);
    root.querySelectorAll('[data-tl-judge]').forEach(box => observer.observe(box,{subtree:true,childList:true,attributes:true,attributeFilter:['data-number-of-reviews']}));
    const track = root.querySelector('.tl-h-track');
    if (!track) return;
    const slides = [...root.querySelectorAll('[data-tl-slide]')];
    const prev = root.querySelector('[data-tl-prev]'), next = root.querySelector('[data-tl-next]');
    if (!slides.length) { prev.disabled = next.disabled = true; root.hidden = true; return; }
    let active = 0, frame = 0, scrollingToTarget = false, scrollFinish;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    function activate(index, announce = false) {
      active = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === active); slide.querySelector('[data-tl-focus]').setAttribute('aria-pressed',String(i === active)); });
      prev.disabled = next.disabled = slides.length < 2;
      if (announce && slides[active]) root.querySelector('[data-tl-announcement]').textContent = slides[active].querySelector('h3').textContent.trim();
    }
    function center(index, announce = true) {
      activate(index, announce);
      if (!slides[active]) return;
      scrollingToTarget = announce && !reducedMotion.matches;
      clearTimeout(scrollFinish);
      if (scrollingToTarget) scrollFinish = setTimeout(() => { scrollingToTarget = false; }, 1600);
      const box = slides[active].getBoundingClientRect(), area = track.getBoundingClientRect();
      track.scrollTo({left:track.scrollLeft + box.left - area.left + box.width / 2 - track.clientWidth / 2,behavior:scrollingToTarget ? 'smooth' : 'auto'});
    }
    slides.forEach((slide,i) => slide.querySelector('[data-tl-focus]').addEventListener('click',() => center(i)));
    prev.addEventListener('click',() => center(active - 1)); next.addEventListener('click',() => center(active + 1));
    track.addEventListener('keydown',e => { if(e.target !== track) return; if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();center(e.key === 'Home' ? 0 : e.key === 'End' ? slides.length - 1 : active + (e.key === 'ArrowLeft' ? -1 : 1));} });
    track.addEventListener('scroll',() => {
      if (scrollingToTarget) {
        clearTimeout(scrollFinish);
        scrollFinish = setTimeout(() => { scrollingToTarget = false; }, 160);
        return;
      }
      cancelAnimationFrame(frame); frame = requestAnimationFrame(() => {
        const middle = track.getBoundingClientRect().left + track.clientWidth / 2;
        let closest = 0, distance = Infinity;
        slides.forEach((slide,i) => { const b = slide.getBoundingClientRect(), d = Math.abs(b.left + b.width / 2 - middle); if(d < distance){distance=d;closest=i;} });
        activate(closest);
      });
    },{passive:true});
    ['pointerdown','touchstart','wheel'].forEach(event => track.addEventListener(event, () => { scrollingToTarget = false; clearTimeout(scrollFinish); }, {passive:true}));
    requestAnimationFrame(() => center(Math.min(2,slides.length - 1),false));
    let resize;
    window.addEventListener('resize',() => {clearTimeout(resize);resize=setTimeout(() => center(active,false),100);});
  }
  function boot(scope = document){scope.querySelectorAll('[data-tl-home]').forEach(init);}
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => boot()); else boot();
  document.addEventListener('shopify:section:load',e => boot(e.target));
})();
